import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#A7A7B1",
      "stroke-linecap": "round",
      "stroke-width": "1.25",
      d: "M3 3v0a2.32 2.32 0 0 1 2.319 2.319v5.797A2.32 2.32 0 0 1 3 13.435v0",
      style: {"stroke":"color(display-p3 .6543 .6543 .6951)","stroke-opacity":"1"}
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M7.638 13.438a2.32 2.32 0 0 1-2.32-2.32V5.323a2.32 2.32 0 0 1 2.32-2.32v0"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.653 4.695c.439 0 .833.267.996.674l1.23 3.076.976 2.44a.625.625 0 0 1-1.16.465l-.819-2.048H8.085l-1.007 2.013a.6.6 0 0 1-.031-.127l-.003-.07v-2.53l1.65-3.3.077-.13c.199-.287.527-.463.882-.463M6.13 11.632h.002zm2.581-3.58h1.666L9.636 6.2z",
      style: {"fill-opacity":".4"}
    }, null, -1)
  ])))
}
export default { render: render }